import { Action } from 'redux';

import { TThunkAction } from '../../types/redux';

export type TSetMortgageTabActiveType = 'mortgage/set_mortgage_tab_active';

export const SET_MORTGAGE_TAB_ACTIVE_TYPE: TSetMortgageTabActiveType = 'mortgage/set_mortgage_tab_active';

export interface ISetMortgageTabActive extends Action<TSetMortgageTabActiveType> {
  type: TSetMortgageTabActiveType;
  isActive: boolean;
}

export type TSetMortgageTabActive = ISetMortgageTabActive;

export function setMortgageTabActive(isActive: boolean): TThunkAction {
  return (dispatch) => {
    dispatch<TSetMortgageTabActive>({
      type: SET_MORTGAGE_TAB_ACTIVE_TYPE,
      isActive,
    });
  };
}
